import gsap from 'gsap'
import { CustomEase } from "gsap/CustomEase";
import * as $ from 'jquery';
import { loadAnimation, start } from 'bodymovin';
import lottie from "lottie-web";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import svghealth from "../anim/healthvector.json";
import svgbusiness from "../anim/businessvector.json";
import svgvacation from "../anim/vacationvector.json";
import svghome from "../anim/homevector.json";

// export var pageload10th = ()=>{
//     pageloading()
// }
// export var starsmove = ()=>{
//     stars()
// }
// export var bigxcall = ()=>{
//     bigX()
// }
export var call_fallstars = ()=>{
    fallstars()
}
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(CustomEase);


function fallstars(){
    console.log("fallstars start")
    this.tl_starfall = gsap.timeline()
    this.tl_starfall.to(".fallstar",{duration:2, y:`+= 30`, ease:"power1.inOut",yoyo: true, repeat:-1, delay: ()=>{return randomNumber(0,1)}, repeatRefresh: true})
}


export function scrollanimationforproject(locoScroll) {

    $(document).ready(function() {
            
        locoScroll.on("scroll", ScrollTrigger.update);
        if(this.timelinegsap){
            this.timelinegsap.kill()
        }
        ScrollTrigger.removeEventListener()
        ScrollTrigger.refresh()

        // each time Locomotive Scroll updates, tell ScrollTrigger to update too (sync positioning)
        locoScroll.on("scroll", ScrollTrigger.update);
        // tell ScrollTrigger to use these proxy methods for the ".smooth-scroll" element since Locomotive Scroll is hijacking things
        ScrollTrigger.scrollerProxy(".smooth-scroll", {
        scrollTop(value) {
            return arguments.length ? locoScroll.scrollTo(value, 0, 0) : locoScroll.scroll.instance.scroll.y;
        }, // we don't have to define a scrollLeft because we're only scrolling vertically.
        getBoundingClientRect() {
            return {top: 0, left: 0, width: window.innerWidth, height: window.innerHeight};
        },
        // LocomotiveScroll handles things completely differently on mobile devices - it doesn't even transform the container at all! So to get the correct behavior and avoid jitters, we should pin things with position: fixed on mobile. We sense it by checking to see if there's a transform applied to the container (the LocomotiveScroll-controlled element).
        // pinType: document.querySelector(".smooth-scroll").style.transform ? "transform" : "fixed"
        });

            // document.querySelector("header").style.transform ? "transform" : "fixed"

            // this.timelinegsap.to("header", {
            //     scrollTrigger: {
            //       trigger: "header",
            //       scroller: "[data-scroll-container]",
            //       scrub: 1,
            //       pin: true,
            //       start: "0% top",
            //     //   end: "100%",
            //     //   markers: true
            //     },
            //     // bottom: "-=10%",
            //     // scale: 5,
            //     // duration: 3,
            //     // transformOrigin: "center bottom", 
            //     // ease: "power2.out"
            //   });
            this.timelinegsap = gsap.timeline()
            gsap.to("header", {
              scrollTrigger: {
                trigger: "header",
                scroller: ".smooth-scroll",
                // scrub: 1,
                pin: true,
                start: "top top",
                endTrigger: "#vacation",
                end: "300% bottom",
                // markers: true
              },
 
              ease: "power2.out"
            });


            this.timelinegsap.to(".box", {
                scrollTrigger: {
                  trigger: ".box",
                  scroller: ".smooth-scroll",
                  scrub: 1,
                  pin: true,
                  start: "0% top",
                  end: "100%",
                //   markers: true
                },
                // bottom: "-=10%",
                scale: 5,
                duration: 3,
                transformOrigin: "center bottom", 
                ease: "power2.out"
              });

              this.timelinegsap.to("#fallstars", {
                scrollTrigger: {
                  trigger: "#tower",
                  scroller: "[data-scroll-container]",
                  start: "100% 100%",
                  end: "+=10%",
                  scrub: 1,
                  // markers: true
                },
                opacity: 0,
                ease: "power2.out"
              });

              this.timelinegsap.to("#tower", {
                scrollTrigger: {
                  trigger: ".sectionpro1",
                  scroller: ".smooth-scroll",
                  scrub: 1,
                  pin: true,
                  start: "bottom bottom",
                  end: "+=100%",
                  // pinSpacing: false,
                  // anticipatePin: false,
                  // markers: true
                },
                // bottom: "-=10%",
                scale: 10,
                autoAlpha: 0,
                transformOrigin: "center bottom", 
                ease: "expo.out",
              });


              document.querySelectorAll(".project").forEach((e)=>{
                gsap.to(e, {
                  scrollTrigger: {
                    trigger: e,
                    scroller: ".smooth-scroll",
                    start: "0% bottom",
                    end: "bottom top",
                    toggleActions: "play resume none none",
                    // markers: true
                  },
                  // bottom: "-=10%",
                  // onUpdate: ()=>{console.log("heloo")},
                  y: "-=50px",
                  duration: 1,
                  opacity: 1,
   
                });
  
              })


              
              ScrollTrigger.addEventListener("refresh", () => locoScroll.update());

              // after everything is set up, refresh() ScrollTrigger and update LocomotiveScroll because padding may have been added for pinning, etc.
              ScrollTrigger.refresh();
              
  

                var animData1 = {
                    container: document.getElementById('homesvg'),
                    renderer: 'svg',
                    loop: false,
                    autoplay: false,
                    animationData: svghome
                };
                var animData2 = {
                  container: document.getElementById('healthsvg'),
                  renderer: 'svg',
                  loop: false,
                  autoplay: false,
                  animationData: svghealth
                };
                var animData3 = {
                    container: document.getElementById('businesssvg'),
                    renderer: 'svg',
                    loop: false,
                    autoplay: false,
                    animationData: svgbusiness
                };
                var animData4 = {
                  container: document.getElementById('vacationsvg'),
                  renderer: 'svg',
                  loop: false,
                  autoplay: false,
                  animationData: svgvacation
                };
                var homeanim = lottie.loadAnimation(animData1);
                var healthanim = lottie.loadAnimation(animData2);
                var businessanim = lottie.loadAnimation(animData3);
                var vacationanim = lottie.loadAnimation(animData4);


                function playAnimOnScoll(options) {
                  ScrollTrigger.create({
                    scroller: ".smooth-scroll",
                    trigger: options.trigger,
                    // markers: true,
                    start: "top bottom",
                    toggleActions: "play null reset reset",
                    onEnter: function() { 
                      options.anim.goToAndPlay(0, 1)
                     },
                    
                  });
                }
                playAnimOnScoll({
                  trigger: "#homesvg",
                  anim: homeanim
                });
                playAnimOnScoll({
                  trigger: "#healthsvg",
                  anim: healthanim
                });
                playAnimOnScoll({
                  trigger: "#businesssvg",
                  anim: businessanim
                });
                playAnimOnScoll({
                  trigger: "#vacationsvg",
                  anim: vacationanim
                });
                homeanim.addEventListener("complete", function() {
                  homeanim.goToAndPlay(114, 1)
                });
                healthanim.addEventListener("complete", function() {
                  healthanim.goToAndPlay(35, 1)
                });
                businessanim.addEventListener("complete", function() {
                  businessanim.goToAndPlay(17, 1)
                });
                vacationanim.addEventListener("complete", function() {
                  vacationanim.goToAndPlay(0, 1)
                });


    })

        
    }

function randomNumber(min, max) {
    return Math.random() * (max - min) + min;
}
